import TextField from "@mui/material/TextField";
import { FieldRenderProps } from "react-final-form";
import { styled } from "@mui/material";
import { FormApi } from "final-form";
import { useEffect } from "react";

interface TextFieldControlSimpleProps {
  type?: string;
  maxLength?: number;
  label?: string;
  helperText?: string;
  autoComplete?: string;
  showDirty?: boolean;
  disabled?: boolean;
  formAPI?: FormApi;
  variant?: "filled" | "outlined" | "standard";
  size?: "medium" | "small";
  className?: string;
}

const TextFieldControlSimple = ({
  input: { onChange, name, value, type, ...inputProps },
  onchange,
  showDirty,
  meta,
  maxLength,
  label,
  helperText,
  placeholder,
  min,
  max,
  disabled,
  formAPI,
  autoComplete,
  variant = "outlined",
  size = "medium",
  className,
  multiline = false,
  ...restProps
}: FieldRenderProps<any> & TextFieldControlSimpleProps) => {
  useEffect(() => {
    if (formAPI) {
      const state = formAPI?.getFieldState(name);
      if (state?.modified) {
        if (meta.initial === value || (type === "number" && Number(meta.initial) === Number(value))) {
          formAPI.resetFieldState(name);
        }
      }
    }
  }, [value]);

  const onBlur = (_e: any) => {
    if (formAPI) {
      formAPI.blur(name);
    }
  };

  const onFocus = (_e: any) => {
    if (formAPI) {
      formAPI.focus(name);
    }
  };

  return (
    <Component
      {...restProps}
      placeholder={placeholder}
      name={name}
      value={value}
      onChange={(e: any) => {
        onChange(e);
        if (onchange) {
          onchange(e);
        }
      }}
      label={label}
      variant={variant}
      size={size}
      disabled={disabled}
      rows={4}
      multiline={multiline}
      helperText={((meta.dirty || meta.touched) && meta.error) || helperText}
      error={Boolean((meta.dirty || meta.touched) && meta.error)}
      InputProps={{
        autoComplete: autoComplete,
      }}
      inputProps={{
        ...inputProps,
        onBlur: inputProps.onBlur ? inputProps.onBlur : onBlur,
        onFocus: inputProps.onFocus ? inputProps.onFocus : onFocus,
        "data-cy": name,
        maxLength,
        min,
        max,
      }}
      type={type}
      className={className + `${meta.dirty && showDirty ? " touched" : ""}`}
      fullWidth
    />
  );
};

const Component = styled(TextField)`
  input {
    //padding: 12px 16px;
  }
  fieldset {
    //top: 0;
  }
  label {
    //color: {({ theme }) => theme.palette.grey.A700};
    //color: rgb(255 255 255 / 45%);
  }
  textarea {
    min-height: 22px;
    resize: vertical;
    max-height: 300px;
  }
  &.touched > .Mui-disabled .MuiOutlinedInput-notchedOutline {
    border-color: rgb(255 182 0 / 70%);
  }
  &.touched {
    & fieldset {
      border-color: rgb(255 182 0 / 70%);
    }
  }
`;

export default TextFieldControlSimple;
